import { RegiaoCidade } from '../regiao-cidade';

export class RegiaoCidadePopula {
    selected: boolean;
    exist: boolean;
    regiaoCidade: RegiaoCidade;
}
